const GroupBMIIcon = (
  <>
    <path
      d="M19.3795 16.728C20.4032 15.1589 21 13.2866 21 11.2734C21 5.75071 16.5227 1.27344 11 1.27344C5.47727 1.27344 1 5.75071 1 11.2734C1 13.2866 1.59682 15.1589 2.62045 16.728H19.3795Z"
      fill="#F0F0F0"
      stroke="#595959"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11 1.27344V3.54616"
      stroke="#999999"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
    />
    <path
      d="M21 11.2734H18.7273"
      stroke="#999999"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
    />
    <path
      d="M1 11.2734H3.27273"
      stroke="#999999"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
    />
    <path
      d="M18.0709 4.20312L16.4641 5.80994"
      stroke="#999999"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
    />
    <path
      d="M3.9292 4.20312L5.53602 5.80994"
      stroke="#999999"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
    />
    <path
      d="M10.3882 9.56107L8.72729 4.91016"
      stroke="#999999"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
    />
    <path
      d="M10.9998 13.0914C12.004 13.0914 12.818 12.2774 12.818 11.2733C12.818 10.2691 12.004 9.45508 10.9998 9.45508C9.99567 9.45508 9.18164 10.2691 9.18164 11.2733C9.18164 12.2774 9.99567 13.0914 10.9998 13.0914Z"
      fill="#F5F4F7"
      stroke="#999999"
      strokeWidth="1.13636"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </>
)

export default GroupBMIIcon
